import {
  doGet,
  doPost
} from '@/api/http'
let apis = '/electricity'

/**
 * 回路列表
 */
export async function loopList (params) {
  let result = await doGet(apis + '/core/loopBase/list', params)
  return result
}

/**
 * 回路新增
 */
export async function loopAdd (params) {
  let result = await doPost(apis + '/core/loopBase/add', params, true)
  return result
}

/**
 * 修改回路
 */
export async function loopEdit (params) {
  let result = await doPost(apis + '/core/loopBase/edit', params, true)
  return result
}

/**
 * 回路详情
 */
export async function getLoopDetailById (params) {
  let result = await doGet(apis + '/core/loopBase/getLoopDetailById', params)
  return result
}

/**
 * 删除回路
 */
export async function loopRemove (params) {
  let result = await doGet(apis + '/core/loopBase/remove', params, true)
  return result
}

/**
 * 网关分页列表
 */
export async function gatewayList (params) {
  let result = await doGet(apis + '/core/gatewayBase/list', params)
  return result
}

/**
 * 新增网关
 */
export async function gatewayAdd (params) {
  let result = await doPost(apis + '/core/gatewayBase/add', params, true)
  return result
}

/**
 * 修改网关
 */
export async function gatewayEdit (params) {
  let result = await doPost(apis + '/core/gatewayBase/edit', params, true)
  return result
}

/**
 * 删除网关
 */
export async function gatewayRemove (params) {
  let result = await doGet(apis + '/core/gatewayBase/remove', params, true)
  return result
}

/**
 * 网关连接状态下拉菜单
 */
export async function getConnectStatus (params) {
  let result = await doGet(apis + '/core/gatewayBase/getConnectStatus', params)
  return result
}

/**
 * 区域分页
 */
export async function regionList (params) {
  let result = await doGet(apis + '/core/regionBase/page', params)
  return result
}

/**
 * 区域详情
 */
export async function getRegionDetailById (params) {
  let result = await doGet(apis + '/core/regionBase/getRegionDetailById', params)
  return result
}

/**
 * 区域删除
 */
export async function regionRemove (params) {
  let result = await doGet(apis + '/core/regionBase/remove', params)
  return result
}

/**
 * 回路下拉菜单
 */
export async function loopDownMenu (params) {
  let result = await doGet(apis + '/core/loopBase/downMenu', params)
  return result
}

/**
 * 区域新增
 */
export async function regionAdd (params) {
  let result = await doPost(apis + '/core/regionBase/add', params, true)
  return result
}

/**
 * 修改区域
 */
export async function regionEdit (params) {
  let result = await doPost(apis + '/core/regionBase/edit', params, true)
  return result
}

/**
 * 从机分页列表
 */
export async function getDetectorPage (params) {
  let result = await doGet(apis + '/core/detectorBase/getDetectorPage', params)
  return result
}

/**
 * 区域下拉
 */
export async function regionDownMenu (params) {
  let result = await doGet(apis + '/core/regionBase/downMenu', params)
  return result
}

/**
 * 网关下拉菜单
 */
export async function gatewayDownMenu (params) {
  let result = await doGet(apis + '/core/gatewayBase/downMenu', params)
  return result
}

/**
 * 从机详情
 */
export async function getDetectorDetailById (params) {
  let result = await doGet(apis + '/core/detectorBase/getDetectorDetailById', params)
  return result
}

/**
 * 从机删除
 */
export async function detectorRemove (params) {
  let result = await doGet(apis + '/core/detectorBase/remove', params)
  return result
}

/**
 * 从机新增
 */
export async function detectorAdd (params) {
  let result = await doPost(apis + '/core/detectorBase/add', params, true)
  return result
}

/**
 * 从机修改
 */
export async function detectorEdit (params) {
  let result = await doPost(apis + '/core/detectorBase/edit', params, true)
  return result
}

/**
 * 从机绑定声光报警
 */
export async function avaBind (data) {
  let result = await doPost(apis + '/core/detectorBase/avaBind', data, true)
  return result
}

/**
 * 声光报警绑定从机
 */
export async function avaBindDetector (data) {
  let result = await doPost(apis + '/core/detectorBase/avaBindDetector', data, true)
  return result
}

/**
 * 获取从机绑定的声光警报从机
 */
export async function getAvaBindDetector (params) {
  let result = await doGet(apis + '/core/detectorBase/getAvaBindDetector', params, false)
  return result
}

/**
 * 获取从机绑定的声光警报设备IF
 */
export async function getIssuingFunctionsByDetectorId (params) {
  let result = await doGet(apis + '/core/detectorBase/getIssuingFunctionsByDetectorId', params, false)
  return result
}

/**
 * 获取声光警报设备IF
 */
export async function getIssuingFunctionsByAvaId (params) {
  let result = await doGet(apis + '/core/detectorBase/getIssuingFunctionsByAvaId', params, false)
  return result
}

/**
 * 获取绑定的从机列表
 */
export async function getDetectorsByDetectorAvaId (params) {
  let result = await doGet(apis + '/core/detectorBase/getDetectorsByDetectorAvaId', params, false)
  return result
}

/**
 * 探测器信息导入
 */
export async function sensorBaseImport (params) {
  let result = await doPost(apis + '/core/sensorBase/import', params, true)
  return result
}

/**
 * 采集信息
 */
export async function addCollectData (params) {
  let result = await doPost(apis + '/core/detectorBase/addCollectData', params, true)
  return result
}

/**
 * 采集内容下拉菜单
 */
export async function collectDataDownMenu (params) {
  let result = await doGet(apis + '/core/regionBase/collectDataDownMenu', params)
  return result
}

/**
 * 数据类型下拉菜单
 */
export async function dataTypeDownMenu (params) {
  let result = await doGet(apis + '/core/regionBase/dataTypeDownMenu', params)
  return result
}

/**
 * 从机下的检测信息列表
 */
export async function getSensorByDetectorId (params) {
  let result = await doGet(apis + '/core/detectorBase/getSensorByDetectorId', params)
  return result
}

/**
 * 用户分页列表
 */
export async function userList (params) {
  let result = await doGet(apis + '/system/user/list', params)
  return result
}

/**
 * 用户详情
 */
export async function getUserById (params) {
  let result = await doGet(apis + '/system/user/getUserById', params)
  return result
}

/**
 * 企业下拉菜单
 */
export async function enterpriseByUserType (params) {
  let result = await doGet(apis + '/core/enterpriseBase/enterpriseTypeDownMenuByUserType', params)
  return result
}

/**
 * 用户类型下拉菜单
 */
export async function userTypeDownMenu (params) {
  let result = await doGet(apis + '/system/user/userTypeDownMenu', params)
  return result
}

/**
 * 用户删除
 */
export async function userremove (params) {
  let result = await doGet(apis + '/system/user/remove', params)
  return result
}

/**
 * 用户新增
 */
export async function userAdd (params) {
  let result = await doPost(apis + '/system/user/add', params, true)
  return result
}

/**
 * 用户修改
 */
export async function userEdit (params) {
  let result = await doPost(apis + '/system/user/edit', params, true)
  return result
}

/**
 * 密码重置
 */
export async function resetPassword (params) {
  let result = await doGet(apis + '/system/user/resetPassword', params, false)
  return result
}

// ************************** 角色 **************************
/**
 * 添加角色
 */
export async function addRole (params) {
  let result = await doPost(apis + '/role/add', params, true)
  return result
}

/**
 * 修改角色
 */
export async function editRole (params) {
  let result = await doPost(apis + '/role/edit', params, true)
  return result
}

/**
 * 获取角色选择列表
 */
export async function optionSelect (params) {
  let result = await doGet(apis + '/role/page', params, false)
  return result
}

/**
 * 角色状态修改
 */
export async function changeStatus (params) {
  let result = await doPost(apis + '/role/changeStatus', params, true)
  return result
}

/**
 * 批量删除角色
 * roleIds=23,24
 */
export async function removeRole (params) {
  let result = await doGet(apis + '/role/remove', params, true)
  return result
}

/**
 * 查询已分配用户角色列表
 * roleId
 * status
 * mobilePhone
 * account
 */
export async function allocatedList (params) {
  let result = await doGet(apis + '/role/allocatedList', params, false)
  return result
}

/**
 * 取消授权用户
 * roleId
 * userId
 */
export async function cancelAuthUser (params) {
  let result = await doPost(apis + '/role/cancelAuthUser', params, true)
  return result
}

/**
 * 批量取消授权用户
 * roleId
 * userIds
 */
export async function cancelAuthUserAll (params) {
  let result = await doGet(apis + '/role/cancelAuthUserAll', params, true)
  return result
}

/**
 * 批量选择用户授权
 * roleId
 * userIds
 */
export async function selectAuthUserAll (params) {
  let result = await doGet(apis + '/role/selectAuthUserAll', params, true)
  return result
}
// ************************** 权限 **************************

/**
 * 加载对应角色菜单列表树
 * roleId
 */
export async function treeSelect (params) {
  let result = await doGet(apis + '/menu/treeSelect', params, false, true)
  return result
}

/**
 * 新增菜单
 */
export async function addMenu (params) {
  let result = await doPost(apis + '/menu/add', params, true)
  return result
}

/**
 * 修改菜单
 */
export async function editMenu (params) {
  let result = await doPost(apis + '/menu/edit', params, true)
  return result
}

/**
 * 删除菜单
 * menuId
 */
export async function removeMenu (params) {
  let result = await doGet(apis + '/menu/remove', params, true)
  return result
}

/**
 * 获取当前用户的菜单信息
 * menuId
 */
export async function getRouters (params) {
  let result = await doGet(apis + '/menu/getRouters', params, false, true)
  return result
}

/**
 * 所有的权限菜单
 */
export async function treeMenu (params) {
  let result = await doGet(apis + '/menu/treeMenu', params, false, true)
  return result
}
